export default "__VITE_ASSET__DC_ZJSwM__"